// extracted by mini-css-extract-plugin
export default {"container":"_4ZskeCfZbARuwQWja3+kLQ==","list":"U7bnj2Iw9qoT0cOM+eJreg==","title":"r3ALHqvAZaztGzMZZkt-6w==","list-item":"d4faV-Iz6+Zs3gE2nqHhDQ=="};